var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99718 0.00069774C4.17481 0.000697756 4.35243 0.0582039 4.49266 0.181431L7.79276 3.08138C8.06387 3.31961 8.06387 3.71394 7.79276 3.95218C7.52165 4.19042 7.07291 4.19042 6.8018 3.95218L3.99718 1.48764L1.19257 3.95218C0.921456 4.19042 0.472719 4.19042 0.201606 3.95218C-0.0695066 3.71394 -0.0695066 3.31961 0.201606 3.08138L3.5017 0.181431C3.64193 0.0582038 3.81956 0.000697724 3.99718 0.00069774Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.c48579836cce743fd6c2274fdb4be13b.svg";
export { ForwardRef as ReactComponent };